import { UIHeading4, UIHeading5, UIText1, UIText2 } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectIsMobileLayout } from '../../../../selectors/layout';
import * as styles from './HighDemandBanner.css';

export const HighDemandBanner = () => {
  const isMobile = useSelector(selectIsMobileLayout);
  const rootStyle = !isMobile ? styles['desktop-container'] : styles['mobile-container'];
  const AdvantageHeading = isMobile ? UIHeading5 : UIText1;

  return (
    <div className={rootStyle}>
      <div className={styles['icon-container']}></div>
      <div className={styles['content']}>
        <UIHeading4>Повышенный спрос</UIHeading4>
        <div className={styles['description-wrapper']}>
          <UIText2>Стоимость размещения увеличена из&#8209;за популярности района</UIText2>
        </div>
        <div className={styles['advantages-container']}>
          <div className={styles['advantage']}>
            <UIText2 color="gray60_100">Объекты сдаются</UIText2>
            <AdvantageHeading>на 40% быстрее</AdvantageHeading>
          </div>
          <div className={styles['advantage']}>
            <UIText2 color="gray60_100">Объявления получают</UIText2>
            <AdvantageHeading>на 70% больше звонков</AdvantageHeading>
          </div>
        </div>
      </div>
    </div>
  );
};
